import { lazy, Suspense, type ComponentProps } from "react"

const Picker = lazy(() =>
  import("./SqlConversationPicker").then((module) => ({
    default: module.SqlConversationPicker,
  })),
)

export function MetricConversationPicker(props: ComponentProps<typeof Picker>) {
  return (
    <Suspense fallback={<p role="status">Loading conversations…</p>}>
      <Picker {...props} />
    </Suspense>
  )
}
